import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-554c5fb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column gap-5"
}
const _hoisted_2 = { class: "w-100 bg-white p-5" }
const _hoisted_3 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_4 = { class: "d-flex justify-content-end mb-5" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-lg" }, null, -1))
const _hoisted_6 = { class: "" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = { class: "text-capitalize" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!
  const _component_AgencyCreateModal = _resolveComponent("AgencyCreateModal")!
  const _component_AgencyUpdateModal = _resolveComponent("AgencyUpdateModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Card, { class: "list-container" }, {
      title: _withCtx(() => [
        _createTextVNode("Partners")
      ]),
      subtitle: _withCtx(() => [
        _createTextVNode("Found " + _toDisplayString(_ctx.table.total) + " " + _toDisplayString(_ctx.agencyText), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_skeleton, {
                  animated: "",
                  row: "5"
                })
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  class: "btn btn-lg btn-primary",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleNew && _ctx.toggleNew(...args)))
                }, [
                  _hoisted_5,
                  _createTextVNode(" Add Partner ")
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_DataTable, {
                  "table-data": _ctx.table.items,
                  "table-header": _ctx.tableHeaders,
                  "enable-items-per-page-dropdown": true,
                  loading: _ctx.table.loading,
                  "rows-per-page": 10,
                  "row-class": "table-hover",
                  "onClick:row": _ctx.viewDetail
                }, {
                  "cell-business_name": _withCtx(({ row: item }) => [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(item.business_name), 1)
                    ])
                  ]),
                  "cell-discount": _withCtx(({ row: item }) => [
                    _createTextVNode(_toDisplayString(item.discount), 1)
                  ]),
                  "cell-description": _withCtx(({ row: item }) => [
                    _createTextVNode(_toDisplayString(item.description), 1)
                  ]),
                  "cell-status": _withCtx(({ row: item }) => [
                    _createVNode(_component_Chip, {
                      type: _ctx.getStatus(item).type,
                      text: _ctx.getStatus(item).text
                    }, null, 8, ["type", "text"])
                  ]),
                  "cell-action": _withCtx(({ row: item }) => [
                    _createElementVNode("a", {
                      class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1",
                      onClick: _withModifiers(($event: any) => (_ctx.editDetail(item)), ["stop"]),
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#agency_modal",
                      href: "javascript:void(0)",
                      title: "Update Agency Details"
                    }, _hoisted_11, 8, _hoisted_9),
                    _createElementVNode("a", {
                      class: "btn btn-icon btn-bg-light btn-active-color-danger btn-sm me-1",
                      onClick: _withModifiers(($event: any) => (_ctx.confirmDelete(item)), ["stop"]),
                      href: "javascript:void(0)",
                      title: "Archive Agency"
                    }, _hoisted_14, 8, _hoisted_12)
                  ]),
                  _: 1
                }, 8, ["table-data", "table-header", "loading", "onClick:row"])
              ])
            ]))
      ]),
      _: 1
    }),
    _createVNode(_component_AgencyCreateModal, {
      modelValue: _ctx.showCreateModal,
      onFormSubmitted: _ctx.handleFormSubimitted,
      onClose: _ctx.handleFormCancelled
    }, null, 8, ["modelValue", "onFormSubmitted", "onClose"]),
    _createVNode(_component_AgencyUpdateModal, {
      modelValue: _ctx.showUpdateModal,
      onFormSubmitted: _ctx.handleFormSubimitted,
      onClose: _ctx.handleFormCancelled
    }, null, 8, ["modelValue", "onFormSubmitted", "onClose"])
  ], 64))
}